import React, { useContext, useEffect, useState } from "react";
// import { PartenerSheepDeedService } from "../services/parternshipservice";
// import CitySelector from "./User/CitySelectore";
// import AuthUser from "../services/AuthUser";
// import { ServicesContext } from "../services/ServicesContext";

// import { handleRazorpayPayment } from "../services/handlePayment";
import { useNavigate } from "react-router-dom";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";
import AuthUser from "../../services/AuthUser";
import { PartenerSheepDeedService } from "../../services/parternshipservice";
import CitySelector from "../User/CitySelectore";





const PfEsicPlan = ({
  title,
  price,
  oldPrice,
  discount,
  requirements,
  inclusions,
  onSubmit,
}) => {

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",
      }));
    }
  }, []);

  const [formVisible, setFormVisible] = useState(false);
  const [newData, setNewData] = useState({ plans: title, prize: price, user_name: '', user_email: '', user_contact: '', user_city: '' })
       const { http, token } = AuthUser();
   const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const { services, loading, error } = useContext(ServicesContext);
  const service = services.find(s => s.service_id === 54);
  const validateForm = () => {
    const newErrors = {};


    if (!newData.user_name.trim()) {
      newErrors.user_name = '*Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }

    if (!newData.user_email.trim()) {
      newErrors.user_email = '*Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    // if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
    //   newErrors.user_contact = '*Enter a valid 10-digit contact number.';
    // }

        if (!newData.user_contact.trim()) {
      newErrors.user_contact = '*number is required.';
    } else if (!/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    if (!newData.user_city) {
      newErrors.user_city = '*City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // No errors
  };


  // Toggle form visibility
  const toggleFormVisibility = () => {
    setFormVisible(!formVisible);
  };

    const currentData = {
          plans: title,
          prize: price,
          user_name: newData.user_name,
          user_email: newData.user_email,
          user_contact: newData.user_contact,
          user_city: newData.user_city,
    };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

        // ✅ Check if user is logged in
        //   if (!token) {
      //      alert("Please log in to continue.");
      //    localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
      //     navigate('/login'); // 👈 Use this if you're using React Router
      //     return;
      //  }
    if (validateForm()) {
    //   try {
    // const currentData = {
    //       plans: title,
    //       prize: price,
    //       user_name: newData.user_name,
    //       user_email: newData.user_email,
    //       user_contact: newData.user_contact,
    //       user_city: newData.user_city,
    // };
    // console.log("Submitting data:", currentData);

    // const data = await PartenerSheepDeedService.tdsReturnForm(currentData);
    // setNewData({
    //   plans: title,
    //   prize: price,
    //   user_name: '',
    //   user_email: '',
    //   user_contact: '',
    //   user_city: '',
    // });


    localStorage.setItem("bookingData", JSON.stringify(currentData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });


    if (onSubmit) {
      onSubmit(currentData);
    }

  }
  };


  // Reset form



return (
  <div className="pricing-plan">
    <div className="price">
      <p className="pp-text">{title}</p>
      {formVisible && (
        <div className="wrapper">
          <button className="getStartdBn btn" onClick={toggleFormVisibility}>
            Close
          </button>
        </div>
      )}


    </div>

    <p className="price-section">
      <span></span> Rs.{price}<span>/Yearly</span>
    </p>





    {formVisible ? (
      <div className="formContainer">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="text-bold" htmlFor="name">
              Name
            </label>{errors.user_name && <p className="error">{errors.user_name}</p>}
            <input
              type="text"
              className="form-control"
              required
              value={newData.user_name}
              onChange={(e) =>
                setNewData({ ...newData, user_name: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label className="text-bold" htmlFor="email">
              Email
            </label> {errors.user_email && <p className="error">{errors.user_email}</p>}
            <input
              type="email"
              className="form-control"
              required
              value={newData.user_email}
              onChange={(e) =>
                setNewData({ ...newData, user_email: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label className="text-bold" htmlFor="mobile">
              Contact no
            </label> {errors.user_contact && <p className="error">{errors.user_contact}</p>}
            <input
              type="tel"
              className="form-control"
              required
              value={newData.user_contact}
              onChange={(e) =>
                setNewData({
                  ...newData,
                  user_contact: e.target.value,
                })
              }
            />
          </div>
          <div className="form-group">
            <CitySelector
              newData={newData}
              setNewData={setNewData}
              fieldKey="user_city"
              errors={errors}
            />
          </div>

          <div class="wrapper">
            <button type="submit" className="getStartdBn btn" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </form>
      </div>
    ) : (
      <div className="yttt">
        <div className="defaultText">

          <div>
            <p className="text-bold">
              <i className="fa fa-star icone"></i> Tasks Included:
            </p>
            <ul>
              {requirements.map((item, index) => (
                <li key={index} className="text-bold">
                  <img src="assets/icons/check.svg" alt="" /> {item}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-bold">
              <i className="fa fa-star icone"></i> Additional Facilities:
            </p>
            <ul>
              {inclusions.map((item, index) => (
                <li key={index} className="text-bold">
                  <img src="assets/icons/check.svg" alt="" /> {item}
                </li>
              ))}
            </ul>
          </div>


        </div>
        <div class="wrapper">
          <button
            className="getStartdBn btn"
            onClick={toggleFormVisibility}
          >
            {formVisible ? "X" : "Get Started"}
          </button>
        </div>
      </div>



    )}
  </div>
);
};

export default PfEsicPlan;
